import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessExplainerByObjectId } from '@api/data-security';

export const getCoreDataSecurityAccessExplainerByObjectIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessExplainerByObjectId',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessExplainerByObjectId,
	retainDataOnRequest: true
});
